module.exports = __webpack_public_path__ + "static/media/6_Patay_L@2x.74fdc852.jpg";